// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"72":"59111025","682":"e7c61ff0","822":"9a5628e0"}[chunkId] + ".css";
};